/**
 * WGN ORIGINAL variant selector helper
 *
 * Companion to snippets/wgn-original-variant-selector.liquid.
 *
 * Provides a small, defensive helper that updates the add-to-cart button state
 * (and hooks for image swap) whenever Shopify.OptionSelectors fires its
 * onVariantSelected callback. Price, sku, payment-button, and inventory display
 * updates are handled by the existing modified theme via the "variant:change"
 * CustomEvent, which the snippet dispatches separately.
 *
 * Adapted from WE-GOT-NUTS ORIGNAL LIVE/assets/timber.js (timber.productPage,
 * lines 193-249) but pruned of dead jQuery selectors that no longer exist
 * in the migrated DOM (#ProductThumbs, .variant-inventory, etc).
 */
(function () {
  if (typeof window.WGN === "undefined") {
    window.WGN = {};
  }

  /**
   * Updates state derived from the currently selected variant.
   *
   * @param {Object}  options
   * @param {Element} options.form           The product form element.
   * @param {Element} [options.picker]       The .wgn-variant-picker element.
   * @param {Object}  [options.variant]      The Shopify variant JSON, or null.
   * @param {String}  [options.moneyFormat]  Shop money format string.
   */
  window.WGN.updateProductPage = function (options) {
    options = options || {};
    var form = options.form;
    var variant = options.variant || null;

    if (!form) return;

    var section = form.closest && form.closest('.shopify-section--main-product');

    // -------------------------------------------------------------------
    // Add-to-cart submit button(s)
    // -------------------------------------------------------------------
    var atcButtons = [];
    if (section) {
      atcButtons = section.querySelectorAll(
        'buy-buttons button[type="submit"], button[name="add"], #AddToCart, .add-to-cart-button'
      );
    } else {
      atcButtons = form.querySelectorAll(
        'button[type="submit"], button[name="add"], #AddToCart'
      );
    }

    if (variant && variant.available) {
      atcButtons.forEach(function (btn) {
        btn.disabled = false;
        btn.classList.remove('disabled');
        btn.removeAttribute('aria-disabled');
      });
    } else {
      atcButtons.forEach(function (btn) {
        btn.disabled = true;
        btn.classList.add('disabled');
        btn.setAttribute('aria-disabled', 'true');
      });
    }

    // -------------------------------------------------------------------
    // Featured image — soft signal only. The migrated gallery has its own
    // listener for variant:change; we do not modify the DOM directly.
    // -------------------------------------------------------------------
    if (variant && variant.featured_image) {
      try {
        document.dispatchEvent(new CustomEvent('wgn:variant:featured-image', {
          detail: {
            variantId: variant.id,
            image: variant.featured_image,
            formId: form.id || null
          }
        }));
      } catch (e) {
        // Ignore in environments without CustomEvent support.
      }
    }

    // -------------------------------------------------------------------
    // SKU display — only a hint; the modified theme has its own SKU block
    // wired to variant:change. This is a no-op when no .variant-sku exists.
    // -------------------------------------------------------------------
    if (section) {
      var skuNodes = section.querySelectorAll('.variant-sku');
      if (skuNodes.length) {
        var skuText = (variant && variant.sku) ? variant.sku : '';
        skuNodes.forEach(function (node) {
          node.textContent = skuText;
        });
      }
    }
  };
})();
